import { useState, useEffect } from 'react';
import { detectUserIntent } from '../utils/intentDetection';
import { UserIntent } from '../types';

export const useIntentDetection = () => {
  const [intent, setIntent] = useState<UserIntent>({
    intent: 'unclassified',
    context: { landingPage: '' },
    skipOnboarding: false,
  });

  useEffect(() => {
    try {
      const detectedIntent = detectUserIntent();
      setIntent(detectedIntent);
    } catch (error) {
      console.error('Error detecting user intent:', error);
      setIntent({
        intent: 'unclassified',
        context: { landingPage: '' },
        skipOnboarding: false,
      });
    }
  }, []);

  return intent;
};
